<template>
  <div class="index">
    <div style="padding: 0 10px">
      <div class="index-top-logo">
        <img
          class="index-top-logo__img"
          :src="logoDisplay"
          alt=""
        />
      </div>
      <div
        style="
          margin-top: 0px;
          background: #fff;
          border-radius: 0 0 10px 10px;
          overflow: hidden;
        "
      >
        <div class="home_msg" style="height: 50px">
          <img
            style="width: 15px; height: 15px"
            src="../../assets/images/new/laba.png"
          />
          <div class="home_msg_con">
            <div
              style="height: 30px"
              v-for="(item, index) in gglist"
              :key="index"
              @click="dianjilb(item.id)"
            >
              <div
                style="
                  height: 30px;
                  line-height: 30px;
                  display: flex;
                  align-items: center;
                "
              >
                <div
                  class="zuoce"
                  style="color: #333; font-size: 13px; flex: 1"
                >
                  {{ item.title }}
                </div>
                <span
                  style="
                    text-align: right;
                    width: 40px;
                    font-size: 11px;
                    color: #666;
                    margin-left: 5px;
                  "
                  >{{ createDate(item.created_at) }}</span
                >
                <img
                  src="../../assets/images/licai/right.png"
                  style="width: 12px; height: 12px; margin-left: 5px"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="index-home-banner-outer">
      <div class="index-home-banner">
        <swiper
          ref="homeBannerSwiper"
          class="index-home-banner-swiper swiper"
          :options="homeBannerSwiperOption"
        >
          <swiper-slide
            v-for="(src, idx) in homeBannerList"
            :key="idx"
            class="index-home-banner-slide"
          >
            <img
              class="index-home-banner-img"
              :src="src"
              alt=""
              @click="onHomeBannerClick(idx)"
            />
          </swiper-slide>
          <div
            id="indexHomeBannerPagination"
            class="swiper-pagination index-home-banner-pagination"
            slot="pagination"
          ></div>
        </swiper>
      </div>
    </div>
    <!-- 首页介绍：公司简介 / 理财优势 / 远东矿业 / 远东黄金 -->
    <div class="index-intro-wrap">
      <section class="index-intro-card">
        <h3 class="index-intro-heading">公司简介</h3>
        <p class="index-intro-text">
          远东贵金属（香港）有限公司是香港知名的贵金属交易服务商，面向零售与机构客户。依托集团在金融投资、矿业生产与贸易领域的综合实力，持有金银业贸易场
          A1 类牌照，提供 99 金、港元公斤条、伦敦金/银等品种。立足大中华，业务辐射东南亚、中东及大洋洲，秉承专业、可靠、高效的服务理念。
        </p>
      </section>
      <section class="index-intro-card index-intro-card--adv">
        <h3 class="index-intro-heading">理财优势</h3>
        <div class="index-intro-adv-grid">
          <div
            v-for="(item, idx) in introAdvantages"
            :key="idx"
            class="index-intro-adv-cell"
          >
            <div class="index-intro-adv-icon">{{ item.ico }}</div>
            <div class="index-intro-adv-title">{{ item.title }}</div>
            <p class="index-intro-adv-desc">{{ item.text }}</p>
          </div>
        </div>
      </section>
      <section class="index-intro-card">
        <h3 class="index-intro-heading">远东矿业</h3>
        <p class="index-intro-text">
          远东集团联动多家矿业开采与控股企业，矿产资源布局涵盖南非、美国、俄罗斯等区域，参与勘探、开采、选矿、冶炼至终端销售的一体化链条，专注黄金产业综合开发。坚持科技与管理创新，强化生产技术、成本控制与区域服务优势，稳步推进资源整合与全国渠道拓展。
        </p>
      </section>
      <section class="index-intro-card">
        <h3 class="index-intro-heading">远东黄金</h3>
        <div class="index-intro-tag">粗金采购 · 供应链服务</div>
        <p class="index-intro-text">
          集团在美洲、俄罗斯、南非、秘鲁等地合作矿山资源，开展粗金采购与配套业务。配备专业服务团队，覆盖选料、定价、通关手续与船运排期等环节，供应链完整；电子交易平台产品丰富、流程透明，保障每一笔黄金相关交易规范、可追溯。
        </p>
      </section>
    </div>
    <div class="index-news-section">
      <div class="index-news-card">
        <header class="index-news-header">
          <h3 class="index-news-title">最新资讯</h3>
          <div class="index-news-more" @click="wayToArticle">
            <span>更多</span>
            <img
              class="index-news-more-ico"
              src="@/assets/images/home/more.png"
              alt=""
            />
          </div>
        </header>
        <div class="index-news-list">
          <div
            v-for="(item, index) in newsList"
            :key="index"
            class="index-news-item"
            @click="
              $router.push({ name: 'article_detail', query: { id: item.id } })
            "
          >
            <div class="index-news-thumb-wrap">
              <img
                v-if="item.image && !item._newsImgErr"
                class="index-news-thumb"
                :src="item.image"
                alt=""
                @error="onNewsImgError(item)"
              />
              <div v-else class="index-news-thumb-fallback">
                <span class="index-news-thumb-fallback-text">资讯</span>
              </div>
            </div>
            <div class="index-news-body">
              <p class="index-news-item-title line-clamp2">{{ item.title }}</p>
              <div class="index-news-item-meta">
                <span class="index-news-item-hint">查看详情</span>
                <template v-if="newsItemTime(item)">
                  <span class="index-news-item-meta-sep" aria-hidden="true">·</span>
                  <span class="index-news-item-time">{{
                    newsItemTime(item)
                  }}</span>
                </template>
              </div>
            </div>
            <img
              class="index-news-chevron"
              src="../../assets/images/licai/right.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div
      style="z-index: 1000"
      v-if="yaoqi && detailData"
      class="mask"
      @click="yaoqi1"
    >
      <div style="position: relative">
        <div
          class="mask-modal modaltwo"
          style="
            width: 300px;
            height: 450px;
            background: linear-gradient(to bottom, #ffc97e, #ffc97e, #ff4600);
            padding: 15px;
            padding-top: 20px;
            padding-bottom: 20px;
          "
        >
          <div style="height: 370px; background: #fff; overflow-y: scroll">
            <div
              v-html="detailData.content"
              class="content"
              style="height: 400px"
            ></div>
          </div>
          <div
            @click="yaoqi1"
            style="
              left: 20px;
              right: 20px;
              position: absolute;
              bottom: 15px;
              margin: 0 auto;
              text-align: center;
              line-height: 40px;
              border-radius: 30px;
              color: #a56400;
              background: linear-gradient(to bottom, #f7e2bf, #ffcd7c);
              font-size: 14px;
              font-weight: bold;
            "
          >
            我已了解
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Socket from "@libs/chat";
import $store from "../../store";
import request from "@utils/request";
import { isKfHttpOnHttpsPage } from "@utils/index";
import { getLogo } from "@api/public";
import "@assets/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

var vm = null;
export default {
  name: "Index",
  props: {},
  components: {
    swiper,
    swiperSlide
  },
  data: function() {
    const homeBannerList = [
      require("../../assets/images/new/banner1.png"),
      require("../../assets/images/new/banner2.png"),
      require("../../assets/images/new/banner3.png"),
      require("../../assets/images/new/banner4.png"),
    ];
    const multi = homeBannerList.length > 1;
    return {
      maichubi: 63.47,
      mairubi: 36.53,
      maichubi1: 64.01,
      mairubi1: 35.99,
      mytime: "",
      socket: null,
      detailData: null,
      yaoqi: true,
      curStartTime: "2019-07-31 08:00:00",
      laitime: "",
      day: "0",
      hour: "00",
      min: "00",
      second: "00",
      jinyinIndex: 0,
      jinyin: {
        jin: 1.0004,
        type1: true,
        fudu1: "+0.0002",
        min1: "1.0000",
        max1: 1.0004,
        bfb1: "-0.0001%",
        yin: 6.35,
        type2: false,
        fudu2: -0.06,
        bfb2: "-0.07%",
        xin: 6.34,
        type3: true,
        fudu3: +0.03,
        bfb3: "+0.04%"
      },
      reRender: true,
      show: false,
      types: 0,
      token: "",
      /** 首页资金区轮播图，按需增删图片路径 */
      homeBannerList,
      homeBannerSwiperOption: {
        autoplay: multi
          ? { disableOnInteraction: false, delay: 3500 }
          : false,
        loop: multi,
        speed: 600,
        autoHeight: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: "#indexHomeBannerPagination",
          clickable: true
        }
      },
      image:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F015ef657bc11150000012e7eafa2e0.png%402o.png&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1634556413&t=2fb650f58dfd37bf68e8ffd138c2dc73",
      // 资讯
      newsList: [],
      /** 首页「理财优势」六宫格（简要文案） */
      introAdvantages: [
        {
          ico: "税",
          title: "税务优势",
          text: "黄金属于全球少数税负较轻的投资品种，除必要进口与保管费用外，一般无额外税费负担。"
        },
        {
          ico: "流",
          title: "市场透明度",
          text: "黄金市场国际化程度高、信息公开，相较部分品种更不易被人为操纵，趋势研判相对清晰。"
        },
        {
          ico: "值",
          title: "保值与变现",
          text: "黄金保值属性突出，急需资金时可抵押或变现，是灵活的安全垫资产。"
        },
        {
          ico: "胀",
          title: "抵御通胀",
          text: "长期看黄金价格与通胀预期关联紧密，是资产配置中应对购买力下降的重要工具之一。"
        },
        {
          ico: "质",
          title: "性质稳定",
          text: "黄金物理与化学性质稳定，易于鉴定、保存与流通，“真金不怕火炼”。"
        },
        {
          ico: "服",
          title: "服务保障",
          text: "7×24 小时在线响应，一对一顾问答疑，全流程陪伴，售后省心。"
        }
      ],
      gglist: [],
      id: "ceshi",
      /** 接口返回的 logo，空则用本地默认图 */
      logoUrl: "",
      defaultLogo: require("../../assets/images/img/img/logo.png")
    };
  },
  beforeDestroy() {
    this.socket && this.socket.close();
  },
  created() {
    vm = this;
    this.token = $store.state.app.token;
    let yy = localStorage.getItem("lang");
    if (yy) {
      if (yy == "en-US") {
        this.$i18n.locale = "en-US";
      } else {
        this.$i18n.locale = "zh-CN";
      }
    }
  },
  activated() {
    this.reRender = false;
    setTimeout(() => {
      this.reRender = true;
    }, 10);
    this.$nextTick(() => {
      const inst = this.$refs.homeBannerSwiper;
      const s = inst && inst.swiper;
      if (s) {
        s.update();
        if (this.homeBannerList.length > 1 && s.autoplay) {
          s.autoplay.start();
        }
      }
    });
  },
  mounted: function() {
    this.detime();
    this.detime1();
    this.$nextTick(() => {
      const s = this.$refs.homeBannerSwiper && this.$refs.homeBannerSwiper.swiper;
      if (s) {
        s.update();
        if (this.homeBannerList.length > 1 && s.autoplay) {
          s.autoplay.start();
        }
      }
    });
    this.socket = new Socket();
    this.socket.vm(this);

    this.$on("onMessage", data => {
      this.jinyinIndex = 1;
      if (data.length > 50) {
        // console.log("数组数据：");
        // console.log(JSON.parse(data[0]));
      }
      if (data.code) {
        if (data.code == "0" && data.data.length > 0) {
          if (data.data[0].usdCny) {
            let cny = data.data[0].usdCny;
            let cce = (cny * this.jinyin.jin).toFixed(2);
            if (this.jinyin.yin <= cce) {
              this.jinyin.type2 = true;
            } else {
              this.jinyin.type2 = false;
            }
            if (this.jinyin.xin <= cny) {
              this.jinyin.type3 = true;
            } else {
              this.jinyin.type3 = false;
            }
            this.jinyin.yin = cce;
            this.jinyin.xin = cny;
          }
        }
      }
      if (data.arg) {
        if (data.arg.channel == "tickers" && data.arg.instId == "USDT-USDK") {
          if (data.data.length > 0) {
            if (this.jinyin.jin <= data.data[0].last) {
              this.jinyin.type1 = true;
            } else {
              this.jinyin.type1 = false;
            }
            this.jinyin.jin = data.data[0].last; //最新价
            this.jinyin.max1 = data.data[0].high24h; //最高价
            this.jinyin.min1 = data.data[0].low24h; //最低价
            let kai = data.data[0].open24h; //开盘价
            let mairu = parseFloat(data.data[0].bidSz); //左边买入量
            let mairu1 = parseFloat(data.data[0].bidSz) - 30000; //右边买入量1
            let maichu = parseFloat(data.data[0].askSz); //左边卖出量
            let maichu1 = parseFloat(data.data[0].askSz) - 30000; //右边卖出量1
            let mairubi = ((mairu / (mairu + maichu)) * 100).toFixed(2); //左边买入比例
            let maichubi = (100 - mairubi).toFixed(2); //左边卖出比例
            this.mairubi = mairubi;
            this.maichubi = maichubi;

            let mairubi1 = ((mairu1 / (mairu1 + maichu1)) * 100).toFixed(2); //右边买入比例
            let maichubi1 = (100 - mairubi1).toFixed(2); //右边卖出比例
            this.mairubi1 = mairubi1;
            this.maichubi1 = maichubi1;
            let cha = (this.jinyin.jin - kai).toFixed(4);
            if (cha >= 0) {
              this.jinyin.fudu1 = "+" + cha;
              this.jinyin.bfb1 = "+" + (cha / kai).toFixed(4) + "%";
            } else {
              this.jinyin.fudu1 = cha;
              this.jinyin.bfb1 = (cha / kai).toFixed(4) + "%";
            }

            let cce = (this.jinyin.yin * this.jinyin.jin).toFixed(2);
            if (this.jinyin.yin <= cce) {
              this.jinyin.type2 = true;
            } else {
              this.jinyin.type2 = false;
            }
            this.jinyin.yin = cce;
          }
        }
      }

      let huilv = this.jinyin.jin * this.jinyin.yin;
      let ss = $store.state.app.huilv;
      if (huilv >= ss) {
        this.shangxia = true;
      } else {
        this.shangxia = false;
      }
      this.$store.commit("HUILV", huilv);
    });
    this.$on("socket_error", () => {
      // this.$dialog.error("连接失败");
    });
    this.$on("err_tip", data => {
      // this.$dialog.error(data.msg);
    });
    this.$on("socket_open", () => {
      // this.$dialog.error("连接成功");
    });
    this.curStartTime = "2022-02-09";
    this.countTime();
    let that = this;
    request
      .post(
        "/api/v1/article/article/list",
        {
          cid: 15,
          page: 1
        },
        {
          login: false
        }
      )
      .then(res => {
        let gglist1 = res.data.data;
        if (gglist1.length > 0) {
          that.detailData = gglist1[0];
        }
      });
    this.$nextTick(function() {
      request
        .post(
          "/api/v1/article/article/list",
          {
            cid: 7,
            page: 1
          },
          {
            login: false
          }
        )
        .then(res => {
          this.gglist = res.data.data;
          let val = Math.max(...this.gglist.map(a => a.sort));
          let saa = [];
          for (let index = 0; index < this.gglist.length; index++) {
            const dic = this.gglist[index];
            if (dic.sort == val) {
              saa.push(dic);
            }
          }
          this.gglist = saa;
        });
    });
    getLogo(2)
      .then(res => {
        if (res && res.data && res.data.logo_url) {
          this.logoUrl = res.data.logo_url;
        }
      })
      .catch(() => {});
    // 活动列表
    request
      .post(
        "/api/v1/article/cat/all",
        {},
        {
          login: false
        }
      )
      .then(res => {
        const raw =
          (res.data &&
            res.data.data &&
            res.data.data[0] &&
            res.data.data[0].list) ||
          [];
        // 首页「最新资讯」仅展示最新 3 条，完整列表见「更多」
        this.newsList = raw.slice(0, 3);
      });
  },
  computed: {
    logoDisplay() {
      return this.logoUrl || this.defaultLogo;
    },
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return h + ":" + m;
      };
    }
  },
  methods: {
    wayToArticle() {
      this.$router.push({ path: "/article" });
    },
    onNewsImgError(item) {
      this.$set(item, "_newsImgErr", true);
    },
    /** 资讯发布时间：接口为 Y-m-d H:i 字符串，或历史 unix 秒 */
    newsItemTime(item) {
      if (!item) return "";
      const t = item.created_at;
      if (t === null || t === undefined || t === "") return "";
      if (typeof t === "number" && t > 0) {
        const d = new Date(t * 1000);
        return isNaN(d.getTime()) ? "" : this.formatNewsDate(d);
      }
      if (typeof t === "string") {
        const s = t.trim();
        if (!s) return "";
        if (/^\d{10,13}$/.test(s)) {
          const sec = s.length === 13 ? parseInt(s, 10) / 1000 : parseInt(s, 10);
          const d = new Date(sec * 1000);
          return isNaN(d.getTime()) ? "" : this.formatNewsDate(d);
        }
        const m = s.match(/^(\d{4}-\d{2}-\d{2} \d{2}:\d{2})/);
        return m ? m[1] : s;
      }
      return "";
    },
    formatNewsDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const h = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      return `${y}-${m}-${day} ${h}:${min}`;
    },
    /** 第 3 张（索引 2，banner3）→ 客服：与底部 Tab「客服」一致（https 页上 http 客服链则整页跳转外链，否则进 /customerService） */
    onHomeBannerClick(idx) {
      if (idx === 2) {
        const kf = String($store.state.app.kf || "").trim();
        if (kf && isKfHttpOnHttpsPage(kf)) {
          window.location.href = kf;
          return;
        }
        this.$router.push({ path: "/customerService" });
        return;
      }
      this.quhuzhuan();
    },
    quhuzhuan() {
      this.$router.push({ path: "/category" });
    },
    detime() {
      let date = new Date();
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      this.mytime = MM + "月" + d + "日" + h + "时" + m + "分" + s + "秒 ";
    },
    detime1() {
      let date = new Date();
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      this.laitime = y + "-" + MM + "-" + d + " " + h + ":" + m;
    },
    yaoqi1() {
      this.yaoqi = false;
    },
    // 倒计时
    countTime() {
      // 获取当前时间
      let date = new Date();
      let now = date.getTime();
      // 设置截止时间
      let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
      let end = endDate.getTime();
      // 时间差
      let leftTime = end - now;
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        // 时
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.hour = h < 10 ? "0" + h : h;
        // 分
        let m = Math.floor((leftTime / 1000 / 60) % 60);
        this.min = m < 10 ? "0" + m : m;
        // 秒
        let s = Math.floor((leftTime / 1000) % 60);
        this.second = s < 10 ? "0" + s : s;
      } else {
        this.day = 0;
        this.hour = "00";
        this.min = "00";
        this.second = "00";
      }
      // 等于0的时候不调用
      if (
        Number(this.hour) === 0 &&
        Number(this.day) === 0 &&
        Number(this.min) === 0 &&
        Number(this.second) === 0
      ) {
        return;
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        setTimeout(this.countTime, 1000);
      }
    },
    dianjilb(index) {
      this.$router.push({
        name: "article_detail",
        query: {
          id: index
        }
      });
    },
  }
};
</script>
<style scoped lang="less">
/* 首页顶部 Logo（与公告区同一白底卡片上沿） */
.index-top-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 8px 10px;
  background: #fff;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid #f2f2f2;
}
.index-top-logo__img {
  max-width: 120px;
  max-height: 35px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  display: block;
}

.index-home-banner-outer {
  border-radius: 10px;
  padding: 0 10px;
  /* 勿 hidden，否则会裁切底部分页小圆点 */
}

.index-home-banner {
  position: relative;
  width: 100%;
  border-radius: 10px;
  overflow: visible;
}

.index-home-banner-swiper {
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
}

.index-home-banner-slide {
  width: 100%;
}

.index-home-banner-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 10px;
}

/deep/ .index-home-banner .swiper-pagination.index-home-banner-pagination {
  position: absolute;
  bottom: 10px !important;
  left: 0;
  right: 0;
  width: 100% !important;
  text-align: center;
  z-index: 3;
  line-height: 1;
  transform: translate3d(0, 0, 0);
}

/deep/
  .index-home-banner
  .index-home-banner-pagination.swiper-pagination-bullets
  .swiper-pagination-bullet {
  width: 8px !important;
  height: 8px !important;
  margin: 0 4px !important;
  background: rgba(0, 0, 0, 0.35) !important;
  border: 2px solid rgba(255, 255, 255, 0.95) !important;
  opacity: 1 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  vertical-align: middle;
}

/deep/
  .index-home-banner
  .index-home-banner-pagination.swiper-pagination-bullets
  .swiper-pagination-bullet-active {
  background: #cda569 !important;
  border-color: #fff !important;
  width: 18px !important;
  border-radius: 9px !important;
}

.meiribox {
  width: 100%;
  padding: 8px 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .mbox {
    background-color: #fcfcfc;
    width: 100%;
    border-radius: 10px;
    padding: 20px 10px;

    .boxtop {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btn {
        height: 30px;
        width: 90px;
        border-radius: 30px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        background-color: var(--bg-color);
      }
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.mask-modal {
  border-radius: 5px;
}

/deep/ .van-circle__text {
  color: #777;
  font-size: 12px;
}

/deep/ .listname:last-child {
  margin-right: 0 !important;
}

/deep/ .swiper-pagination-bullet {
  border: 2px solid #fff;
  background: #dfdfdf;
}

/deep/ .swiper-pagination-bullet-active {
  // 这以下的代码是你需要的
  background: #fff;
  border: 0px solid #fff;
}

.danshu {
  width: 90%;
  display: inline-block;
  margin-right: 10px;
  padding: 20px 15px 20px 15px;
  border-radius: 10px;
  position: relative;
  border: 0px solid #fff;
  background-size: 100% 100%;
  background-color: #e8e8e8;
}

.line-clamp2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.line-clamp1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.home_vip_block {
  border-right: 1px solid #eceeed;
  width: 50%;
  padding: 20px 0px;
}

.home_vip_block:last-child {
  border: 0px;
}

.home_tab_item {
  padding: 0px 0px;
}

.home_con_block {
  padding: 0px 15px;
  margin-top: 15px;
}

.home_con_text {
  width: 100%;
}

.home_con_list {
  margin-top: 10px;
}

.home_con_list_block {
  width: 50%;
}

.home_con_block img {
  width: 100%;
  height: 110px;
}

.name {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000;
}

.names {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #666;
  margin-left: 3%;
  padding: 3px 5px;
}

.trip {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #d3d3d3;
}

.home_tab_item_block {
  margin-top: 10px;
  font-size: 14px;
  width: 25%;
  margin-left: 5%;
  text-align: center;
  padding-bottom: 5px;
}

/* .home_tab_item_block:first-child{margin-left: 0px;} */
.home_tab_item_blocks {
  color: #CDA569;
  border-bottom: 3px solid #CDA569;
  font-size: 14px;
}

.home_vip_block img {
  width: 27px;
  height: 29px;
  margin: 0 auto;
  display: block;
}

.home_vip_block p {
  text-align: center;
  font-size: 13px;
  color: #000000;
  margin-top: 8px;
}

.home_vip_block:last-child img {
  width: 40px;
  height: 27px;
  margin: 0 auto;
  display: block;
}

.home_line {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 15px;
}

.home_line img {
  border-radius: 5px;
  height: 98px;
  flex: 1;
  margin-right: 1.5%;
}

.home_line img:first-child {
  width: 43%;
}

.home_line img:last-child {
  margin-right: 0px;
}

.home_block {
  margin-top: 0px;
  // background: #fff;

  padding: 5px 0px;
  padding-bottom: 15px !important;
}

.home_block_list {
  width: 24%;
  margin-top: 15px;
}

.home_block_list p {
  text-align: center;
  font-size: 13px;
  font-family: Microsoft YaHei;
  //   font-weight: 600;
  color: #fff;
  margin-top: 6px;
}

.home_block_list_img {
  width: 30px;
  height: 30px;
  margin: 0 auto;
  display: block;
  margin-bottom: 8px;
}

.home_block_list_img img {
  width: 100%;
  height: 100%;
}

.home_msg_con {
  margin-left: 5px;
  flex: 1;
  font-size: 14px;
  line-height: 21px;
}

.home_msg img {
  width: auto;
  height: 14px;
}

.home_msg {
  // overflow: hidden;
  border-top: 1px solid #eee;
  //  background:  linear-gradient(to right,#fff,#FAF9EC);

  height: 60px;
  display: flex;
  align-items: center;
  margin: 0px 10px;
}

[v-cloak] {
  display: none;
}

/* 清除浮动*/
.am-fl {
  float: left;
}

.am-fr {
  float: right;
}

.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.am-cf {
  zoom: 1;
}

.overflow1 {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.index {
  background-color: #fff;
  padding-bottom: 70px;
}

.index .follow {
  z-index: 100000;
}

.keep {
  text-align: center;
}

.productSort_block_left_xh {
  max-width: 220px;
  overflow: hidden;
  /*超出部分隐藏*/
  white-space: nowrap;
  /*禁止换行*/
  text-overflow: ellipsis;
  /*省略号*/
  margin-bottom: 5px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 36px;
}

.zuoce {
  // max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 13px;
  color: #666;
}

.zuoce1 {
  color: #666;
  font-size: 11px;
}

.productSort_block_left_dm {
  border: 1px solid #ffa68c;
  color: #ffa68c;
  padding: 2px 5px;
  border-radius: 2px;
  margin-left: 10px;
  font-size: 11px;
}

.productSort_block_last {
  padding: 0px 9px;
  align-items: center;
  display: flex;
}

.productSort_block_last_item:last-child {
  margin-left: 60px;
}

.productSort_block_left {
  display: flex;
  align-items: center;
  padding: 0 9px;
  margin-bottom: 6px;
  justify-content: space-between;
}

.productSort_con_list {
  padding: 10px 10px;

  border-radius: 10px;
}

.productSort_block {
  position: relative;

  width: 100%;
  background-color: #ffffff;
  padding: 10px 0px;
  margin-bottom: 10px;
}

.productSort_block img {
  width: 100%;
  height: 86px;
}

.productSort_top {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 0 6px;
  /* justify-content: space-between; */
}

.productSort_top_block {
  flex-shrink: 0;

  display: inline-block;
  margin-right: 14px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  text-align: center;
}

.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
}

.productSort_top_blocks {
  border-bottom: 2px solid #CDA569;
  color: #CDA569;
}

/deep/ .mask .content img {
  width: 100% !important;
}
// 商城
.goods-box {
  display: flex;
  margin: 10px 0px;
  background: rgb(255, 255, 255);
  padding: 10px 15px 2px 10px;
  border-radius: 10px;
  .goods-list {
    width: 23%;
    margin: 5px 1%;
  }
  .goods-img {
    width: 100%;
    border-radius: 6px;
  }
  .goods-title {
    font-size: 12px;
    font-weight: 600;
  }
  .goods-price {
    font-size: 13px;
    color: #CDA569;
  }
  .el-h-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* 首页 — 品牌介绍（公司简介 / 理财优势 / 远东矿业 / 远东黄金） */
.index-intro-wrap {
  padding: 12px 12px 0;
}

.index-intro-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(205, 165, 105, 0.2);
  padding: 14px 14px 16px;
  margin-bottom: 12px;
}

.index-intro-card--adv {
  padding-bottom: 14px;
}

.index-intro-heading {
  margin: 0 0 12px;
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: 0.02em;
  position: relative;
  padding-left: 10px;
}

.index-intro-heading::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: linear-gradient(180deg, #d4b87a 0%, #cda569 100%);
}

.index-intro-text {
  margin: 0;
  font-size: 13px;
  line-height: 1.75;
  color: #555;
  text-align: justify;
}

.index-intro-tag {
  display: inline-block;
  font-size: 11px;
  color: #9a7b45;
  background: rgba(205, 165, 105, 0.14);
  padding: 3px 10px;
  border-radius: 20px;
  margin: -6px 0 10px;
  font-weight: 500;
}

.index-intro-adv-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.index-intro-adv-cell {
  background: linear-gradient(180deg, #fdfcfa 0%, #faf7f2 100%);
  border-radius: 10px;
  padding: 12px 10px 12px;
  border: 1px solid rgba(205, 165, 105, 0.14);
  min-height: 0;
}

.index-intro-adv-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d8bf88 0%, #cda569 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  box-shadow: 0 2px 6px rgba(205, 165, 105, 0.35);
}

.index-intro-adv-title {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  margin-bottom: 6px;
  line-height: 1.3;
}

.index-intro-adv-desc {
  margin: 0;
  font-size: 11px;
  line-height: 1.55;
  color: #666;
}

/* 首页 — 最新资讯 */
.index-news-section {
  padding: 0 12px 4px;
}

.index-news-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(205, 165, 105, 0.2);
  overflow: hidden;
}

.index-news-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 14px 10px;
  border-bottom: 1px solid #f0f0f0;
}

.index-news-title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: 0.02em;
  position: relative;
  padding-left: 10px;
}

.index-news-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: linear-gradient(180deg, #d4b87a 0%, #cda569 100%);
}

.index-news-more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #888;
  padding: 4px 2px;
  flex-shrink: 0;
}

.index-news-more-ico {
  width: 13px;
  height: 13px;
  opacity: 0.75;
}

.index-news-list {
  padding: 4px 0 6px;
}

.index-news-item {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  transition: background 0.15s ease;
}

.index-news-item:active {
  background: #faf8f4;
}

.index-news-item + .index-news-item {
  border-top: 1px solid #f2f2f2;
}

.index-news-thumb-wrap {
  flex-shrink: 0;
  width: 108px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f0e6;
  box-shadow: inset 0 0 0 1px rgba(205, 165, 105, 0.15);
}

.index-news-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.index-news-thumb-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    rgba(205, 165, 105, 0.18) 0%,
    rgba(205, 165, 105, 0.05) 100%
  );
}

.index-news-thumb-fallback-text {
  font-size: 12px;
  color: #b8955a;
  font-weight: 500;
  letter-spacing: 0.05em;
}

.index-news-body {
  flex: 1;
  min-width: 0;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.index-news-item-title {
  margin: 0;
  font-size: 15px;
  line-height: 1.45;
  font-weight: 600;
  color: #222;
}

.index-news-item-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 6px;
}

.index-news-item-hint {
  font-size: 12px;
  color: #cda569;
}

.index-news-item-meta-sep {
  font-size: 12px;
  color: #ccc;
  user-select: none;
}

.index-news-item-time {
  font-size: 11px;
  color: #999;
  line-height: 1.2;
}

.index-news-chevron {
  flex-shrink: 0;
  width: 12px;
  height: 12px;
  margin-left: 8px;
  opacity: 0.45;
}
</style>
